import { render } from "./ShowReport.vue?vue&type=template&id=2b54e694"
import script from "./ShowReport.vue?vue&type=script&lang=js"
export * from "./ShowReport.vue?vue&type=script&lang=js"

import "./ShowReport.vue?vue&type=style&index=0&id=2b54e694&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\60\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__